import { render, staticRenderFns } from "./WalletStatement.vue?vue&type=template&id=07370d0e&scoped=true&"
import script from "./WalletStatement.vue?vue&type=script&lang=js&"
export * from "./WalletStatement.vue?vue&type=script&lang=js&"
import style0 from "./WalletStatement.vue?vue&type=style&index=0&id=07370d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07370d0e",
  null
  
)

export default component.exports